import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { MARKS, BLOCKS } from '@contentful/rich-text-types';
import Layout from '../layout/layout';
// import { Disqus } from 'gatsby-plugin-disqus';
import Snippet from '../components/snippet';
import Frame from '../components/frame';
import hljs from 'highlight.js/lib/core';
import html from 'highlight.js/lib/languages/xml';
import js from 'highlight.js/lib/languages/javascript';
import css from 'highlight.js/lib/languages/css';

const options = {
    renderNode: {
        [BLOCKS.EMBEDDED_ENTRY] : (node, children) => {
            if (node.data.target.__typename === 'ContentfulCodepen') {
                return <Frame url={node.data.target.iframeUrl} />
            }
            else {
                return (
                    <Snippet markdown={node.data.target.snippet.snippet} filename={node.data.target.filename} />
                );
            }
        },
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
            const image = getImage(node.data.target);
            return <GatsbyImage image={image} alt={''} />;
        }
    },
    renderMark: {
      [MARKS.BOLD]: (text) => <b className="font-bold">{text}</b>,
      [MARKS.CODE]: (text) => <code className='blog__inline-code'>{text}</code>
    },
}

const Blog = ({ data: {blog} }) => {
    const date = new Date(blog.date);
    const image = getImage(blog.blogImage);
    const disqusConfig = {
        url: `/blogs/${blog.slug}`,
        identifier: blog.slug,
        title: blog.title
    }

    useEffect(() => {
        hljs.registerLanguage('xml', html);
        hljs.registerLanguage('javascript', js);
        hljs.registerLanguage('css', css);
        hljs.configure({ ignoreUnescapedHTML: true});
        hljs.highlightAll();
    }, []);

    const renderDate = () => {
        return `${date.toLocaleString('en-us', { month: 'long' })} ${date.getDate()}, ${date.getFullYear()}`;
    }
    
    return (
        <Layout title={blog.title} description={blog.description.description}>
            <div className='blog'>
                <div className='container'>
                    <div className='blog__hero'>
                        <GatsbyImage image={image} alt='' />
                    </div>
                    <h1 className='blog__header'>{blog.title}</h1>
                    <div className='blog__date'>{renderDate()}</div>
                    <div className='blog__description'>{blog.description.description}</div>
                    <div className='blog__rich-text'>
                        { renderRichText(blog.blogSummary, options)}
                    </div>
                    <div className='blog__comments'>
                        {/* <Disqus config={disqusConfig} /> */}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Blog;

export const pageQuery = graphql`
    query($slug: String!){
        blog: contentfulBlog(slug: {eq: $slug}) {
            title
            slug
            date(formatString: "YYYY-MM-DD")
            description {
                description
            }
            blogSummary {
                raw
                references {
                    ... on ContentfulCode {
                        contentful_id
                        __typename
                        id
                        snippet {
                            snippet
                        }
                        filename
                    }
                    ... on ContentfulAsset {
                        contentful_id
                        __typename
                        id
                        gatsbyImageData(
                            placeholder: BLURRED
                            layout: CONSTRAINED
                            cropFocus: CENTER
                            formats: [AUTO, WEBP]
                            resizingBehavior: NO_CHANGE
                            cornerRadius: 12
                        )
                    }
                    ... on ContentfulCodepen {
                        contentful_id
                        __typename
                        iframeUrl
                    }
                }
            }
            blogImage {
                contentful_id
                gatsbyImageData(
                    placeholder: BLURRED
                    height: 420
                    layout: FULL_WIDTH
                    cropFocus: CENTER
                    formats: [AUTO, WEBP]
                    aspectRatio: 1
                    resizingBehavior: CROP
                  )
            }
        }
    }
`;